import { render, staticRenderFns } from "./quickOpenDoc.vue?vue&type=template&id=467a1686&"
import script from "./quickOpenDoc.vue?vue&type=script&lang=js&"
export * from "./quickOpenDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports